<template>
  <f-list-item variant="default" class="vstudio20-presets-preset-top">
    <div class="vstudio20-presets-preset">
      <!-- <div class="vstudio20-layers-layer-dnd-handle">
      <i class="fa fa-arrows-v"></i>
    </div> -->

      <div class="vstudio20-layers-layer-title" @click="$emit('rename')" :title="preset.title" v-tippy="{
        content: preset.title,
        allowHTML: true,
        arrow: true
      }">
        {{ preset.title }}
      </div>

      <div class="actions">
        <f-tooltip placement="left" :delay="[400, 0]">
          <template #text>
            <span style="font-size: 80%;">
              <Key v-for="modifier in shortKey.modifiers">{{modifier}}</Key>
              <Key>{{ shortKey.key }}</Key>
            </span>
          </template>
          <f-button class="apply-button" type="tertiary small" :disabled="animated" @click="apply">
            <transition mode="out-in">
              <span v-if="!animated" class="text" key="apply"> {{ $vt('Apply') }} </span>
              <span v-else class="check" key="check">
                <i class="fa fa-check" aria-hidden="true"></i>
              </span>
            </transition>
          </f-button>
        </f-tooltip>
        <f-button class="set-button" type="tertiary small" @click="$emit('set')">{{ $vt('Save') }}
        </f-button>
        <f-button type="transparent small icon" class="vstudio20-button delete-button" @click="$emit('delete')">
          <f-icon icon="fa-times"></f-icon>
        </f-button>
      </div>
    </div>
  </f-list-item>
</template>
<script>

import Key from "./Key.vue";

async function wait(time = 1000) {
  return new Promise((resolve) => {
    setTimeout(resolve, time);
  });
}
export default {
  translate25Context: 'vstudio20_presets',
  components: {
    Key
  },
  data: function () {
    return {
      animated: false,
    };
  },
  methods: {
    async apply() {
      this.$emit("apply");
      try {
        this.animated = true;
        await wait(1000);
      } finally {
        this.animated = false;
      }
    },
    save() {
      this.handler.action(this.preset["#id"], "save_preset", []);
    },
  },
  props: ["preset", "handler", "shortKey"],
  mounted() { },
};
</script>

<style lang="scss">


.vstudio20-presets-preset-top {
  height: 42px;
}

.vstudio20-presets-preset {
  display: flex;
  flex-direction: row;
  font-size: 14px;
  line-height: 1.83;
  text-align: left;
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;

  justify-content: space-between;

  .vstudio20-layers-layer-title {
    display: inline;
    border-bottom: 1px dashed #5cbab6;
    color: var(--white-a75);

    overflow: hidden;
    display: inline-block;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .actions {
    display: flex;
    flex-direction: row;
    align-items: center;

    .vstudio20-button,
    .f-button {
      line-height: 14px;
      text-transform: uppercase;

      margin-left: 10px;

      font-size: 12px;

      &.apply-button {
        min-width: 5.2em;

        justify-content: center;

        border: none;

        .text {
          &.v-enter-active,
          &.v-leave-active {
            transition: all 100ms ease;
          }

          &.v-enter,
          &.v-leave-to {
            opacity: 0;
            transform: translateY(10px);
          }
        }

        .check {
          &.v-enter-active {
            transition: 250ms ease;
            transition-property: opacity transform;
          }
          &.v-leave-active {
            transition: 100ms ease;
            transition-property: opacity;
          }

          &.v-enter,
          &.v-leave-to {
            opacity: 0;
            transform: scale(0.5) rotate(360deg);
          }
        }
      }

      &.apply-button,
      &.set-button {
        font-size: 12px;
        font-weight: bold;
        line-height: 18px;

        text-transform: uppercase;
        font-size: 12px;
        font-weight: bold;
        letter-spacing: 1px;
        padding: 5px 10px;
      }

      &.delete-button {
        font-size: 14px;
      }
    }
  }
}
.dark-mode
{
  .vstudio20-presets-preset {

  .vstudio20-layers-layer-title {
    border-bottom: 1px dashed var(--primary);
  }
  }
}
</style>